import { IBrandOrder } from "@faire/web-api/indigofair/data/IBrandOrder";
import React from "react";
import { SOYOProcessing } from "./updateTrackingInfo/SOYOProcessing";
import { SOYOShipped } from "./updateTrackingInfo/SOYOShipped";
import { SWFProcessing } from "./updateTrackingInfo/SWFProcessing";
import { SWFShipped } from "./updateTrackingInfo/SWFShipped";
export var UpdateTrackingInfoIA = function UpdateTrackingInfoIA(_ref) {
  var shippingContext = _ref.shippingContext,
    isSwf = _ref.isSwf;
  var orderState = shippingContext.state;
  if (!isSwf && orderState === IBrandOrder.State.PROCESSING) {
    return /*#__PURE__*/React.createElement(SOYOProcessing, null);
  } else if (isSwf && orderState === IBrandOrder.State.PROCESSING) {
    return /*#__PURE__*/React.createElement(SWFProcessing, null);
  } else if (!isSwf && orderState === IBrandOrder.State.SHIPPED) {
    return /*#__PURE__*/React.createElement(SOYOShipped, null);
  } else if (isSwf && orderState === IBrandOrder.State.SHIPPED) {
    return /*#__PURE__*/React.createElement(SWFShipped, null);
  }
  return null;
};